import initAllPluginUrls from './js/plugins/init-plugins';

initAllPluginUrls();

import(/* webpackPreload: true */ './bootstrap.js');
